import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { NotificationsService } from './notificationsApi';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';
import { INotificationsListState } from '../../../../interfaces/notifications/INotificationsListState';
import { PaginatedNotifications } from '../../../../interfaces/notifications/paginatedStore.type';

const initialState: INotificationsListState = {
    notificationsAreLoading: false,
    notificationIsLoading: false,
    requestStatus: 'default',
    message: '',
};

export const tryToFetchAllNotifications = createAsyncThunk<any, undefined | null>(
    'notifications/tryToFetchAllNotifications',
    async () => {
        const result = await NotificationsService.tryToFetchAllNotifications();
        return result?.data;
    }
);

export const tryToFetchNotifications = createAsyncThunk<PaginatedNotifications, IPaginationPayload>(
    'notifications/tryToFetchNotifications',
    async ({ pageNumber, pageSize, filters, data }) => {
        const result = await NotificationsService.tryToFetchNotifications(
            pageNumber,
            pageSize,
            data,
            filters,
        );
        return result?.data;
    },
);

export const tryToFetchSingleNotification = createAsyncThunk<any, string>(
    'notifications/tryToFetchSingleNotification',
    async (id) => {
        const result = await NotificationsService.tryToFetchSingleNotification(id);
        return result?.data;
    }
);

export const notificationsSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // tryToFetchAllNotifications
            .addCase(tryToFetchAllNotifications.pending, (state) => {
                state.notificationsAreLoading = true;
            })
            .addCase(tryToFetchAllNotifications.rejected, (state) => {
                state.notificationsAreLoading = false;
            })
            .addCase(tryToFetchAllNotifications.fulfilled, (state, action) => {
                state.notificationsAreLoading = false;
                state.allNotifications = action.payload;
            })

            // tryToFetchNotifications
            .addCase(tryToFetchNotifications.pending, (state) => {
                state.notificationsAreLoading = true;
            })
            .addCase(tryToFetchNotifications.rejected, (state) => {
                state.notificationsAreLoading = false;
            })
            .addCase(tryToFetchNotifications.fulfilled, (state, action) => {
                state.notificationsAreLoading = false;
                state.notifications = action.payload;
            })

            // tryToFetchSingleNotification
            .addCase(tryToFetchSingleNotification.pending, (state) => {
                state.notificationIsLoading = true;
            })
            .addCase(tryToFetchSingleNotification.rejected, (state) => {
                state.notificationIsLoading = false;
            })
            .addCase(tryToFetchSingleNotification.fulfilled, (state, action) => {
                state.notificationIsLoading = false;
                state.notification = action.payload;
            })

    },
});

export default notificationsSlice.reducer;